export default {
    roles: [],
    role: {
        selected: null
    },
    permissions: []
}
